import { Injectable } from '@angular/core'
import { Observable } from 'rxjs/Rx'
import 'rxjs/add/operator/map'
import 'rxjs/add/operator/map'
import 'rxjs/add/operator/catch'
import 'rxjs/add/observable/throw'
import { PreguntaPrimerNivel } from '../dominio/pregunta-primer-nivel'
import { RespuestaPrimerNivel } from '../dominio/respuesta-primer-nivel'
import {Declaracion} from '../dominio/declaracion'
import {Prospecto, Ocupacion} from '../dominio/prospecto'
import { Conclusion } from 'app/dominio/conclusion'
import { Decision, Tipo } from 'app/dominio/decision'
import { RespuestaSecundaria } from '../dominio/respuesta-secundaria';
import { PreguntaSecundaria } from '../dominio/pregunta-secundaria';

@Injectable()
export class TransformacionService {

  transformarJsonapiADeclaracion(json: any, nomOcupacion: string): Declaracion {
    const atributos = json.data.attributes
    const p = json.data.relationships.prospecto.data.attributes
    const ocupacion = new Ocupacion(
      p.ocupacion.id,
      p.ocupacion.nombre,
      p.ocupacion.clasificaciones
    )
    const prospecto = new Prospecto(p.id, p.peso, p.talla, p.sexo, ocupacion, p.edad, p.imc)

    let preguntasSecundarias = []
    if (json.data.relationships.preguntasSecundarias) {
      preguntasSecundarias = this.transformarPreguntasSecundarias(json.data.relationships.preguntasSecundarias)
    }

    const preguntasPrimerNivel = this.transformarJsonapiAPreguntasPrimerNivel(
      json.data.relationships.preguntasPrimerNivel,
      preguntasSecundarias
    )

    const conclusiones = this.transformarConclusionesRespuestas(json)
    return new Declaracion(atributos.idSolicitud,
      prospecto,
      preguntasPrimerNivel,
      preguntasSecundarias,
      conclusiones,
      atributos.fecha,
      atributos.ramo,
      atributos.subRamo,
      atributos.canal,
      atributos.deltaPeso,
      nomOcupacion
    )
  }

  transformarJsonapiAPreguntasPrimerNivel(json: any, ps: PreguntaSecundaria[] = []): PreguntaPrimerNivel[] {
    return json.data
      .map( p => {
        let respuestas = []
        if (p.relationships) {
          respuestas = p.relationships.respuestas.data
            .map( r => {
              let preguntasSecundarias = []
              if (r.attributes.idSiguiente) {
                preguntasSecundarias = this.obtenerSecuenciaPreguntasSecundarias(r.attributes.idSiguiente, ps)
              }
              return new RespuestaPrimerNivel(
                r.id,
                r.attributes.texto,
                r.attributes.textoAbierto,
                r.attributes.indice,
                r.attributes.noAsegurable,
                preguntasSecundarias,
                r.attributes.idSiguiente
              )
            })
            .sort(this.ordenarPorIndice)
        }
        return new PreguntaPrimerNivel(
          p.id,
          p.attributes.texto,
          p.attributes.indice,
          respuestas,
          p.attributes.tipo
        )
      })
      .sort(this.ordenarPorIndice)
  }

  obtenerSecuenciaPreguntasSecundarias(idPregunta: string, preguntasSecundarias: PreguntaSecundaria[], secuenciaPreguntas: PreguntaSecundaria[] = []) {
    const indicePregunta = preguntasSecundarias.findIndex(x => x.id === idPregunta)
    
    if (indicePregunta < 0) return secuenciaPreguntas
    
    const p = preguntasSecundarias[indicePregunta]
    secuenciaPreguntas.push(p)
    const res = p.respuestas.find(r => !!r.idSiguiente)
    if (res && res.idSiguiente) {
      return this.obtenerSecuenciaPreguntasSecundarias(res.idSiguiente, preguntasSecundarias, secuenciaPreguntas)
    }
    return secuenciaPreguntas
  }

  private indexarCobertura(amparo: string): Number {
    const indices = { vid: 1, mac: 2, iva: 3, ive: 4, itp: 5, efg: 6, vcn: 7, vgc: 8, vrd: 9, pau: 10, gex: 11 }
    return indices[amparo] ? indices[amparo] : 100
  }

  transformarPreguntasSecundarias(json): PreguntaSecundaria[] {
    return json.data.map(p => this.transformarPreguntaSecundaria(p))
  }

  transformarPreguntaSecundaria(json): PreguntaSecundaria {
    const respuestas = json.relationships.respuestas.data.map(r =>
      new RespuestaSecundaria(r.id, r.attributes.texto, r.attributes.indice, r.attributes.idSiguiente)
    )
    const ps = new PreguntaSecundaria(json.id, json.attributes.texto, respuestas)
    if (respuestas.length === 1) {
      ps.respuestaSeleccionada = respuestas[0].id
    }
    return ps
  }

  transformarConclusionesRespuestas(json) {
    const conclusiones = this.transformarConclusionesJsonApi(json.data.relationships.conclusiones.data)
    const decisionesPriorizadas = json.data.attributes.decisionesPriorizadas || []
    type Fila = {
      parametros: Object[],
      razones: string[],
      cobertura: string,
      tiposDecisiones: string[],
      descripcion: string[],
      resultado: {},
      indice: Number
    }

    const s = conclusiones.reduceRight<Fila[]>( (anterior, actual) => {
      actual.decisiones.forEach( d => {
        if (!anterior[d.cobertura]) {
          anterior[d.cobertura] = {
            parametros: [],
            razones: [],
            cobertura: d.cobertura,
            tiposDecisiones: [],
            descripcion: [],
            resultado: {},
            indice: this.indexarCobertura(d.cobertura)
          }
          anterior[d.cobertura].resultado = decisionesPriorizadas.filter( e => e.cobertura === d.cobertura)
        }
        const posEx = anterior[d.cobertura].tiposDecisiones.indexOf(d.tipo.tipo)
        if (posEx !== -1) {
          anterior[d.cobertura].parametros[posEx].push(d.tipo.parametros)
          anterior[d.cobertura].razones[posEx] = anterior[d.cobertura].razones[posEx].concat(actual.razones)
          anterior[d.cobertura].descripcion[posEx].push(d.texto)
        } else {
          anterior[d.cobertura].parametros.push([d.tipo.parametros])
          anterior[d.cobertura].razones.push(actual.razones)
          anterior[d.cobertura].descripcion.push([d.texto])
          anterior[d.cobertura].tiposDecisiones = anterior[d.cobertura].tiposDecisiones.concat(d.tipo.tipo)
        }
      })
      return anterior
    }, [])
    
    return Object.keys(s).map(key => s[key])
  }

  transformarConclusionesJsonApi(cs: any): Conclusion[] {
    return cs.map( c => {
      const decisiones = this.transformarDecisionesJsonApi(c.relationships.decisiones.data)
      return new Conclusion(c.attributes.texto, decisiones, c.attributes.razones)
    })
  }

  transformarDecisionesJsonApi(ds: any) {
    return ds.map( d => new Decision(d.attributes.texto, d.attributes.cobertura, new Tipo(d.attributes.tipo, d.attributes.params)))
  }

  ordenarPorIndice(a, b) {
    return a.indice - b.indice
  }
}



// WEBPACK FOOTER //
// ./src/app/servicios/transformacion.service.ts